import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from './authentication/authentication.service';

type Action = 'read' | 'create' | 'update' | 'delete';
type Capabilities = Record<string, Record<Action, boolean>>;
export const routeResources: Record<string, string> = {
  'audience-segments':'remarketing','marketing-campaigns':'remarketing','notification-templates':'remarketing',
  integrations:'company', 'media-types':'media_type', 'device-types':'device', roles:'role', companies: 'company', users: 'user', devices: 'device', promotions: 'promotion', advices: 'advice',
  media: 'media', customers: 'customer_profile', coupons: 'promotion',
  'promotion-redemptions': 'promotion', 'app-entities':'app_entity', 'app-versions':'app_version', clients: 'client', 'api-keys': 'api_key', invoices: 'invoice'
};

@Injectable({ providedIn: 'root' })
export class CapabilitiesService {
  private http = inject(HttpClient);
  private auth = inject(AuthenticationService);
  private sessionKey = '';
  private pending?: Promise<void>;
  private expiresAt = 0;
  readonly permissions = signal<Capabilities>({});
  readonly unavailable = signal(false);

  async load(): Promise<void> {
    const user = this.auth.getUser();
    const key = `${user?.id}:${user?.role?.role}:${user?.role?.level}:${user?.company?.id ?? user?.companyId}`;
    if (this.sessionKey === key && this.pending && Date.now() < this.expiresAt) return this.pending;
    this.sessionKey = key;
    this.expiresAt = Date.now() + 60000;
    this.permissions.set({});
    this.pending = firstValueFrom(this.http.get<Capabilities>(`${environment.apiUrl.replace(/\/$/, '')}/auth/capabilities`))
      .then(data => { if (this.sessionKey === key) { this.permissions.set(data); this.unavailable.set(false); } })
      .catch(() => { if (this.sessionKey === key) { this.unavailable.set(true); this.pending = undefined; } });
    return this.pending;
  }

  can(resource: string, action: Action = 'read'): boolean {
    return this.permissions()[resource]?.[action] === true;
  }

  canVisit(path: string): boolean {
    if(path.split(/[?#]/)[0]==='/integrations')return this.can('company')||this.can('api_key');
    const resource = routeResources[path.split('/').filter(Boolean)[0]];
    return !resource || this.can(resource);
  }
}
